// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-suplementos-base{
    color: #fff;
    background-color: #dc3545;
    border-color: #d32535;
    padding: 10px;
    border-radius: 10px;
    font-size: 13px;
}
.card-suplementos-agregados{
    color: #fff;
    background-color: #28a745;
    border-color: #23923d;
    padding: 10px;
    border-radius: 10px;
    font-size: 13px;
}
.lbl-suplementos{
    font-size: 15px;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/analisis-alimentacion/suplementacion/suplementacion.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".card-suplementos-base{\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #d32535;\n    padding: 10px;\n    border-radius: 10px;\n    font-size: 13px;\n}\n.card-suplementos-agregados{\n    color: #fff;\n    background-color: #28a745;\n    border-color: #23923d;\n    padding: 10px;\n    border-radius: 10px;\n    font-size: 13px;\n}\n.lbl-suplementos{\n    font-size: 15px;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
